module.exports = __webpack_public_path__ + "333584c2950bbb1574d1d874a1119c01.woff2";